import React from 'react';
import PropTypes from 'prop-types';

function InfoIcon({ className = '', ...props }) {
  return (
    <svg fill='none' stroke='currentColor' viewBox='0 0 24 24' className={className} {...props}>
      <circle cx='12' cy='12' r='10' />
      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 16v-4' />
      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 8h.01' />
    </svg>
  );
}

InfoIcon.propTypes = {
  className: PropTypes.string,
};

export default InfoIcon;
